import { extendObservable, computed } from 'mobx'

import { projectApi } from '@atheneum/api'

import ClientFeedbackModel from '@models/Project/ClientFeedback.model'

class ClientFeedbackStore {
  constructor () {
    extendObservable(this, {
      error: null,
      loading: false,
      feedbacks: [],
      averageRating: computed(this.getAverageRating)
    })
  }

  load (projectId) {
    this.loading = true
    this.feedbacks.clear()
    return projectApi
      .getClientFeedbacks(projectId)
      .then(feedbackDataList => {
        const feedbacks = feedbackDataList.map(f => new ClientFeedbackModel(f))
        this.feedbacks.replace(feedbacks)
        this.loading = false
      })
      .catch(error => {
        this.error = error
        this.loading = false
        this.growlStore.showError(error)
        console.error(error)
      })
  }

  getAverageRating () {
    if (!this.feedbacks || !this.feedbacks.length) return null

    const validFeedbacks = this.feedbacks.filter(
      feedback => feedback && feedback.averageRating
    )
    if (!validFeedbacks.length) return null

    const sum = validFeedbacks.reduce(
      (total, feedback) => total + feedback.averageRating,
      0
    )
    if (!sum) return null

    return Number(sum / validFeedbacks.length).toFixed(2)
  }
}

export default ClientFeedbackStore
